import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import {PLAN_TYPE_SOURCE} from '../CreateRecommend/RecommendSourceDestination/constants';
import {
  getPotContactId,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
  getIsMinor,
} from './helpers';
import validateUUID from '../../../utils/validateUUID';

const getAdHocFeeVariables = async ({
  accountId,
  ovrecommendId,
  values,
  contacts = [],
}: updateRecsVarsProps): Promise<UpsertOvrecommendVariables> => {
  const {contact} = values;
  const isMinor = getIsMinor(contact, contacts);

  return {
    action: OVRecommendActionEnum.AD_HOC_FEE,
    ovrecommendId: validateUUID(ovrecommendId),
    accountId: validateUUID(accountId),
    contactId: getPotContactId(contact, isMinor),
  };
};

export default getAdHocFeeVariables;

export const generateAdHocFeeOVRPots = async ({
  accountId,
  ovrecommendId,
  values,
  generateRecommendationPots,
  pots,
}: updateRecommendPotsVariables) => {
  const {adHocFee} = values;
  // let potId = values.modify?.source.id;
  let potId = values.adHocFee?.planId;
  const pot = pots ? pots.find((x) => x.id === potId) : null;
  if (pot?.parent?.id) {
    potId = pot.parent.id;
  }
  if (potId) {
    await generateRecommendationPots({
      variables: {
        accountId: validateUUID(accountId)!,
        ovrecommendId: validateUUID(ovrecommendId)!,
        args: [
          {
            potId: validateUUID(potId)!,
            planType: PLAN_TYPE_SOURCE,
            adhocFeeAmount:
              adHocFee?.feeType === 'GBP' ? adHocFee?.monetaryFee : adHocFee?.percentFee,
            adhocFeeType: adHocFee ? adHocFee.feeType : null,
            // adhocFeeDate:
            //   newUTCDate(adHocFee?.instructionDate).toISOString()?.split('T')?.[0] || '',
            adhocFeeReason: adHocFee?.reason,
          },
        ],
      },
    });
  }
};
